let _selected_tasks = []
let _vue

class TaskSelector {

  constructor(vue) {
    _vue = vue

    _vue.$on('TaskSelector::deselect-all', () => {
      _.each(_selected_tasks, task => _vue.$emit('TaskSelector::deselect', task))
      _selected_tasks = []
      this.updated()
    })

    _vue.$on('TaskSelector::deselect', (task) => {
      _vue.$set(task, 'selected', false)
      _selected_tasks = _.reject(_selected_tasks, t => t.id === task.id)
      this.updated()
    })

    _vue.$on('TaskSelector::select', (task) => {
      _vue.$set(task, 'selected', true)
      _selected_tasks.push(task)
      this.updated()
    })

  }

  updated() {
    _vue.$emit('TaskSelector::updated', {selected_tasks: _selected_tasks})
  }

}

export default TaskSelector



// WEBPACK FOOTER //
// ./src/views/agenda-v2/TaskSelector.js